import {theme} from "Theme";
import {PermitExtensionMaterialsForm, PermitExtensionTreesForm} from "./form";
import {PermitExtensionMaterialsTable, PermitExtensionTreesTable} from ".";
import {SectionCard} from "base/ui/section/components";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

const PermitExtensionFeesSummary = ({extension}) => {
    return (
        <>
            <SectionCard dense>
                {["felling", "cutting"].some(type =>
                    extension?.types?.includes(type)
                ) ? (
                    <>
                        <Typography variant="h6" mb={1}>
                            Árvores
                        </Typography>
                        <Box sx={{backgroundColor: "grey.100"}}>
                            <PermitExtensionTreesForm extension={extension}>
                                <PermitExtensionTreesTable
                                    extension={extension}
                                    displayFees={false}
                                    disabled
                                />
                            </PermitExtensionTreesForm>
                        </Box>
                        <Divider sx={{mt: 2, mb: 3}} />
                    </>
                ) : null}
                {extension?.types?.includes("transport") ? (
                    <>
                        <Typography variant="h6" mb={1}>
                            Materiais
                        </Typography>
                        <Box sx={{backgroundColor: "grey.100"}}>
                            <PermitExtensionMaterialsForm extension={extension}>
                                <PermitExtensionMaterialsTable
                                    extension={extension}
                                    displayFees={false}
                                    disabled
                                />
                            </PermitExtensionMaterialsForm>
                        </Box>
                        <Divider sx={{mt: 2, mb: 3}} />
                    </>
                ) : null}
                {extension?.types?.includes("clearing") ? (
                    <>
                        <Typography variant="h6" mb={1}>
                            Área a desbravar
                        </Typography>

                        <Stack direction="row" justifyContent="center">
                            <Stack
                                minWidth="20%"
                                alignItems="center"
                                p={2}
                                sx={{
                                    backgroundColor: "grey.100",
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    color="grey.600"
                                    mt={0.5}
                                    mb={2}
                                >
                                    Autorização original
                                </Typography>
                                <Typography variant="body2" component="span">
                                    {extension?.permit?.clearing_area} ha
                                </Typography>
                            </Stack>
                            <Stack
                                minWidth="20%"
                                alignItems="center"
                                p={2}
                                sx={{
                                    borderLeft: `3px solid ${theme.palette.primary.main}`,
                                    backgroundColor:
                                        theme.palette.pageBackground.secondary,
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    color="grey.600"
                                    mt={0.5}
                                    mb={2}
                                >
                                    Prorrogação
                                </Typography>
                                <Typography variant="body2" component="span">
                                    {extension?.clearing_area} ha
                                </Typography>
                            </Stack>
                        </Stack>
                    </>
                ) : null}
            </SectionCard>
        </>
    );
};

export default PermitExtensionFeesSummary;
